import useMediaQuery from "../../../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { useTanstack } from "../../../../hooks/useTanstack";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../components/ui/button";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/scss";
import styles from "./about.module.scss";

export const About = () => {
  const mobile = useMediaQuery("( max-width: 650px )");

  const { t } = useTranslation();
  const { data } = useTanstack("getWebBackground", false);

  const navigate = useNavigate();

  return (
    <div className={styles.about}>
      <div className={styles.about_fixed}>
        <h1>{t("webname")}</h1>
        {!mobile && (
          <Button
            text="btn_event"
            onClick={() => navigate("news?year=all")}
            type="button"
          />
        )}
      </div>
      <Swiper
        spaceBetween={0}
        pagination={{
          clickable: true,
        }}
        speed={2500}
        loop={true}
        modules={[Autoplay]}
        navigation={true}
        updateOnWindowResize={false}
        slidesPerGroup={1}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
      >
        {data?.map((el, index) => {
          return (
            <SwiperSlide
              key={index}
              className={styles.about_slide}
              // style={{ backgroundImage: `url(${el})` }}
            >
              <img src={el} alt="aboutImg" loading="lazy" />
              {!mobile && (
                <div
                  className={styles.about_slide_overlay}
                  aria-hidden="true"
                />
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
